export default "__VITE_ASSET__B38gX2CH__"